<div class="grid place-items-center tk-grid-rows h-screen tk-bg-gray-1 tk-i-background">

  <div [formGroup]="form" class="mx-auto flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">{{'reset-password.header' | translate}}</div>

    <div class="mt-4 tk-c-gray text-xs text-center">{{'reset-password.provide-email' | translate}}</div>

    <mat-form-field class="mt-2 mb-3" hideRequiredMarker>
      <mat-label>{{'fields-names.email' | translate}}</mat-label>
      <input matInput formControlName="email" autocomplete="off">
      <mat-error id="email-error-required" *ngIf="emailCtrl.hasError('required')">
        {{'errors.field-is-required' | translate}}
      </mat-error>
      <mat-error id="email-error-email" *ngIf="emailCtrl.hasError('email')">
        {{'errors.email-format-incorrect' | translate}}
      </mat-error>
    </mat-form-field>

    <app-button [isLoading]="isLoading" [isFullWidth]="true" [isActive]="!form.pristine" innerTextClasses="my-1.5"
                spinnerClasses="my-3" label="{{'reset-password.header' | translate}}" (click)="onReset()"></app-button>
  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>

</div>
